export var FocusComponent;
(function (FocusComponent) {
    FocusComponent[FocusComponent["MailCompose"] = 0] = "MailCompose";
    FocusComponent[FocusComponent["MailList"] = 1] = "MailList";
    FocusComponent[FocusComponent["ReadingPane"] = 2] = "ReadingPane";
})(FocusComponent || (FocusComponent = {}));
var componentPriorityList = [
    FocusComponent.MailCompose,
    FocusComponent.MailList,
    FocusComponent.ReadingPane,
];
var registeredComponents = {};
/**
 * Register a component as available to be focused on
 */
export function registerComponent(component, setFocusCallback) {
    var componentKey = getFocusComponentKey(component);
    // There can be 2 reading panes when openening SxS
    if (registeredComponents[componentKey] && component !== FocusComponent.ReadingPane) {
        throw new Error('Component has already registered a focus manager callback');
    }
    registeredComponents[componentKey] = setFocusCallback;
}
/**
 * Unregister a component as no longer available to be focused on
 */
export function unregisterComponent(component) {
    registeredComponents[getFocusComponentKey(component)] = null;
}
/**
 * Determine which component should get focus and executes its callback to set focus
 * @returns promise that resolves when focus operation has been performed
 */
export function resetFocus() {
    return new Promise(function (resolve, reject) {
        window.requestAnimationFrame(function () {
            for (var _i = 0, componentPriorityList_1 = componentPriorityList; _i < componentPriorityList_1.length; _i++) {
                var component = componentPriorityList_1[_i];
                var setFocusCallback = registeredComponents[getFocusComponentKey(component)];
                // When we find a registered component in the priority list,
                // execute its set focus callback until focus() on the target element succeeds
                if (setFocusCallback && setFocusCallback()) {
                    return resolve();
                }
            }
            return resolve();
        });
    });
}
function getFocusComponentKey(component) {
    return FocusComponent[component];
}
//# sourceMappingURL=mailModuleAutoFocusManager.js.map